import { MAXtimateCalculator } from '@/modules/calculator';
import Navbar from '@/components/navbar';

export default function EnhancedCalculatorPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <MAXtimateCalculator />
    </div>
  );
}